<template>
  <div class="design-width content impressum-page">
    <div class="sectionIntro">
      <aside class="richtext richtext--narrow impressum" v-if="contents">
        <h1 class="hidden" v-html="contents.title"></h1>
        <div class="sectionIntro__text impressum__text" v-html="contents.text"></div>
      </aside>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import {ax, baseURL} from "../js/api";
import {pageMeta, pageTitle} from "../js/meta";

export default defineComponent({
  metaInfo: pageMeta({ title: pageTitle('Impressum') }),
  data: function () {
    return {
      contents: null,
    }
  },
  created() {
    ax.get(`${baseURL}/api/impressum`).then(response => {
      this.contents = response.data;
    });
  },
});
</script>

<style lang="scss">
  @import '../styles/_toolbox';

  // keep the page tall even before the CMS response arrives, otherwise the
  // footer intersects immediately and the header locks into its overlay state
  .impressum-page {
    min-height: 100vh;
  }

  .impressum {
    padding-top: var(--size-content-stack);
  }

  // nested under .impressum for specificity: the global .richtext p/h2 rules
  // in main.scss would otherwise win and render legal text at display size
  .impressum .impressum__text {
    max-width: 90rem;

    p {
      font-size: calc(var(--size-font-size) * 1.2);
      line-height: 1.5;
      margin-top: var(--size-grid-gutter);
    }

    h2 {
      font-size: var(--size-font-size--medium);
      line-height: 1.1;
      margin-bottom: var(--size-grid-gutter);

      @include viewport(phone) {
        font-size: calc(var(--size-font-size--medium) * 0.6);
      }
    }

    h3 {
      font-size: var(--size-font-size--small);
      line-height: 1.2;
      margin-top: var(--size-content-stack);
      margin-bottom: var(--size-grid-gutter);

      @include viewport(phone) {
        font-size: calc(var(--size-font-size--small) * 0.8);
      }
    }

    strong {
      font-weight: 600;
    }

    a {
      text-decoration: underline;
    }
  }
</style>
